import { getDeep } from '@shared/utils/getDeep.js';
import { setDeep } from '@shared/utils/setDeep.js';
import { store } from '../../../../redux/lib/configureStore';
import { action } from '@/lib/api.js';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';

const projectActions = {
  set(path, payload, opts) {
    return new Promise((resolve) => {
      if (!opts?.projectId) {
        console.error('Project ID is required');
        return;
      }

      const state = store.getState();
      const projects = state?.settings?.integrationsProjects || [];
      const project = projects.find((p) => p.id === opts.projectId);

      const newProject = setDeep(project, path, payload);
      const value = getDeep(path, newProject);

      action('PUT_PROJECT', { data: [newProject] });
      pushChangesQueueItem('project', { projectId: newProject?.id, path, value });
      resolve(newProject);
    });
  }
};

export default projectActions;
